var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 48C28 48 24 48 24 44C24 40 28 28 44 28C60 28 64 40 64 44C64 48 60 48 60 48H28ZM44 24C47.1826 24 50.2348 22.7357 52.4853 20.4853C54.7357 18.2348 56 15.1826 56 12C56 8.8174 54.7357 5.76516 52.4853 3.51472C50.2348 1.26428 47.1826 0 44 0C40.8174 0 37.7652 1.26428 35.5147 3.51472C33.2643 5.76516 32 8.8174 32 12C32 15.1826 33.2643 18.2348 35.5147 20.4853C37.7652 22.7357 40.8174 24 44 24V24Z",
    fill: "#E62569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.864 47.9998C20.271 46.751 19.9753 45.3819 20 43.9998C20 38.5798 22.72 32.9998 27.744 29.1198C25.2364 28.3471 22.6238 27.9692 20 27.9998C4 27.9998 0 39.9998 0 43.9998C0 47.9998 4 47.9998 4 47.9998H20.864Z",
    fill: "#E62569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24C20.6522 24 23.1957 22.9464 25.0711 21.0711C26.9464 19.1957 28 16.6522 28 14C28 11.3478 26.9464 8.8043 25.0711 6.92893C23.1957 5.05357 20.6522 4 18 4C15.3478 4 12.8043 5.05357 10.9289 6.92893C9.05357 8.8043 8 11.3478 8 14C8 16.6522 9.05357 19.1957 10.9289 21.0711C12.8043 22.9464 15.3478 24 18 24V24Z",
    fill: "#E62569"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.9e3a2faf4262c1f03bb35b56197cba5f.svg";
export { ForwardRef as ReactComponent };